import { render, staticRenderFns } from "./WorkspacesDashboard.vue?vue&type=template&id=d46a891e&scoped=true&"
import script from "./WorkspacesDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkspacesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacesDashboard.vue?vue&type=style&index=0&id=d46a891e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46a891e",
  null
  
)

export default component.exports